import type { PropsWithChildren } from "react";

import * as styles from "./overlay.scss";

export interface OverlayProps {
	isVisible: boolean;
}

export function Overlay({ isVisible, children }: PropsWithChildren<OverlayProps>) {
	return <div className={isVisible ? styles.backgroundVisible : styles.background}>{children}</div>;
}
